<template>
  <router-link :to="category.type + '/' + category.id">
    <div class="relative rounded shadow overflow-hidden transition m-2"
         @touchstart="toggleAnimation($event)" @touchend="toggleAnimation($event)">
      <img :src="category.photo.path" alt="">
      <div class="absolute w-full h-full bg-gray-500/30 flex items-center justify-center top-0">
        <span class="text-lg text-white">{{ category.name }}</span>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "CategoryCard",
  props: ['category'],
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle('scale-95')
      event.currentTarget.classList.toggle('shadow')
    }
  }
}
</script>

<style scoped>

</style>